import { i18n } from '@/common/utils/i18n'

export const BIZ_SHOP_STATUS_MAP = {
  '1': '营业中',
  '2': '暂停营业',
  '3': '系统暂停营业',
  '4': '停止营业'
}

export const SHOP_SIGN_PROCESS_CLASS_MAP = {
  '1': 'finish',
  '2': 'wait',
  '3': 'warning',
  '4': 'error',
  '5': 'success',
  '6': 'warning',
  '7': 'warning'
}

export const SHOP_SIGN_PROCESS_MAP = {
  '1': '已完成',
  '2': '未完成',
  '3': '审核中',
  '4': '驳回',
  '5': '审核通过',
  '6': '驳回已修改',
  '7': '待商家确认'
}

export const SHOP_LICENSE_VALID_TYPE_MAP = {
  '1': '长期有效',
  '2': '固定有效期'
}

export const SHOP_SIGN_ACCOUNT_TYPE = {
  '1': '对公',
  '2': '对私'
}

export const SHOP_SIGN_SETTLE_TYPE = {
  '1': '自动结算',
  '2': '商家自提',
  '3': '商家自提+系统自动结算'
}

export const SHOP_ONLINE_TYPE = {
  '1': '不是高峰期时段',
  '2': '高峰前不在线',
  '3': '高峰时不在线'
}

export const SHOP_ONLINE_STATUS = {
  '1': 'APP未启动',
  '2': '未上线'
}

export const SHOP_SIGN_DELIVERY_TYPE = {
  '1': {
    text: '平台配送'
  },
  '2': {
    text: '商家配送'
  },
  '3': {
    text: '商家配送 + 平台配送'
  }
}
export const DAYS_MAP = {
  1: i18n.gettext('周一'),
  2: i18n.gettext('周二'),
  3: i18n.gettext('周三'),
  4: i18n.gettext('周四'),
  5: i18n.gettext('周五'),
  6: i18n.gettext('周六'),
  7: i18n.gettext('周日')
}

const ONLINE_STATUS_ENUM = {
  'ONLINE': 1,
  'TEMP': 2,
  'REST': 3,
  'OFFLINE': 4,
  'CLOSE': 5,
  'FORBID': 6,
  'CONTROL': 7,
  'DEFAULT': 0
}
export const ONLINE_STATUS_OBJ = {
  [ONLINE_STATUS_ENUM['ONLINE']]: 'suc',
  [ONLINE_STATUS_ENUM['TEMP']]: 'normal',
  [ONLINE_STATUS_ENUM['REST']]: 'normal',
  [ONLINE_STATUS_ENUM['OFFLINE']]: 'abnormal',
  [ONLINE_STATUS_ENUM['CLOSE']]: 'normal',
  [ONLINE_STATUS_ENUM['FORBID']]: 'abnormal',
  [ONLINE_STATUS_ENUM['CONTROL']]: 'abnormal',
  [ONLINE_STATUS_ENUM['DEFAULT']]: ''
}

const BIZ_STATUS_ENUM = {
  'ONLINE': 1,
  'TEMP': 2,
  'FORBID': 3,
  'REST': 10,
  'DEFAULT': 0
}

export const BIZ_STATUS_OBJ = {
  [BIZ_STATUS_ENUM['ONLINE']]: 'suc',
  [BIZ_STATUS_ENUM['TEMP']]: 'normal',
  [BIZ_STATUS_ENUM['REST']]: 'normal',
  [BIZ_STATUS_ENUM['FORBID']]: 'abnormal',
  [BIZ_STATUS_ENUM['DEFAULT']]: ''
}

export const BIZ_STATUS_MAP = {
  1: i18n.gettext('正常经营'),
  2: i18n.gettext('暂停经营'),
  3: i18n.gettext('封禁中'),
  10: i18n.gettext('歇业中')
}

export const ONLINE_STATUS_MAP = {
  1: i18n.gettext('营业中'),
  2: i18n.gettext('暂停营业中'),
  3: i18n.gettext('歇业中'),
  4: i18n.gettext('掉线中'),
  5: i18n.gettext('打烊中'),
  6: i18n.gettext('封禁中'),
  7: i18n.gettext('平台管控中')
}
